import React from 'react';

export default class Paginador extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount(){}

  paginas(total, limit, offset){
    let paginas = [];
    if (offset === 0) offset = 1;
    const cantidad = Math.ceil(parseInt(total)/parseInt(limit));
    const seleccionada = (Math.ceil(parseInt(offset)/parseInt(limit))) +1;

    if (cantidad > 4){
      if (seleccionada > 4 && seleccionada < (cantidad - 3)){
        paginas.push({id:1, seleccionada:false},{id:2, seleccionada:false}, {id:'...', puntos:true});
        paginas.push({id:seleccionada - 1, seleccionada:false}, {id:seleccionada, seleccionada:true}, {id:seleccionada + 1, seleccionada:false});
        paginas.push({id:'...', puntos:true}, {id:cantidad - 1, seleccionada:false}, {id:cantidad, seleccionada:false});

      } else if (seleccionada < 6){
        for (var i = 1; i <= 5; i++) {
          paginas.push({
            id:i,
            seleccionada:seleccionada == i
          })
        }
        paginas.push({id:'...', puntos:true}, {id:cantidad - 1, seleccionada:false}, {id:cantidad, seleccionada:false});
      } else if (seleccionada > (cantidad - 5)) {
        for (var i = cantidad; i >= cantidad - 4; i--) {
          paginas.push({
            id:i,
            seleccionada:seleccionada == i
          })
        }
        paginas.reverse();
        paginas = [{id:1, seleccionada:false},{id:2, seleccionada:false}, {id:'...', puntos:true}, ...paginas]
      }
    } else {
      for (var i = 1; i <= cantidad; i++) {
        paginas.push({
          id:i,
          seleccionada:seleccionada == i
        })
      }
    }

    return(paginas)
  }
  setOffset(index, limit){
    return(parseInt(index - 1) * parseInt(limit))
  }

  render(){
    const {total, limit, offset, setOffset} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'row', overflow:'hidden', flexWrap:'wrap', alignItems:'center', justifyContent:'center'}}>
        {this.paginas(total, limit, offset).map((item, index) => {
          return(
            <span
              key={index}
              style={{
                padding:'5px 8px',
                margin:2,
                borderStyle:'solid',
                borderRadius:3,
                borderColor:'lightgrey',
                borderWidth:1, color:'black',
                backgroundColor: item.puntos ? 'lightgrey' : parseInt(item.id) - 1 === parseInt(offset) / parseInt(limit) ? "lightblue": "white",
                cursor:item.puntos ? 'not-allowed' :'pointer',
              }}
              onClick={() =>item.puntos ? {} : setOffset(this.setOffset(item.id, limit))}
            >
              {item.id}
            </span>
          )
        })}
      </div>
    )
  }
}

/*
  <Paginador
    total={total}
    limit={limit}
    offset={offset}
    setOffset={(offset) => {window.scrollTo(0,0);this.setOffset(offset)}}
  />
*/
